import { NextIntlClientProvider } from 'next-intl';
import { FC, useContext } from 'react';
import { BlofinContext } from '../../blofin-provider/auth/BlofinProvider';
import { IpDialog } from './IpDialog';
import { BUITheme } from '@blofin/blofin-ui';

const Index: FC<{ theme?: BUITheme }> = ({ theme }) => {
  const { state } = useContext(BlofinContext);

  const { lang = 'en', messages } = state;

  return (
    <NextIntlClientProvider locale={lang} timeZone="Europe/Vienna" messages={messages.components}>
      <IpDialog theme={theme} />
    </NextIntlClientProvider>
  );
};

export { Index as IpDialog };
